import { createSlice } from "@reduxjs/toolkit";

import api from "../../helpers/axios";
import {
  GET_ALL_SURVEYS,
  GET_CLIENT_DASHBOARD,
  GET_CRR_RESULTS,
  GET_MIL_MASTERDATA,
  GET_PROGRESS_GRAPH_DATA,
} from "../../helpers/url_helpers";
import { setLocalStorage } from "../../helpers/utils";

const initialState = {
  loading: false,
  employeeDashboardData: "",
  crrGraphData: [],
  allSurveysList: [],
  milMasterData: [],
  progressGraphData: [],
  employeeDashboardLoading: false,
  activeSurveyId: "",
};

const employeeDashboard = createSlice({
  name: "employeeDashboard",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },
    setEmployeeDashboardData: (state, action) => {
      state.employeeDashboardData = action.payload.employeeDashboardData;
    },
    setCrrGraphData: (state, action) => {
      state.crrGraphData = action.payload.crrGraphData;
    },
    setAllSurveys: (state, action) => {
      const activeSurvey = action?.payload?.allSurveysList[0]?.id;
      state.activeSurveyId = activeSurvey;
      setLocalStorage("ACTIVE_SURVEY", activeSurvey);
      state.allSurveysList = action.payload.allSurveysList;
    },
    setMilMasterData: (state, action) => {
      state.milMasterData = action.payload.milMasterData;
    },
    setProgressGraphData: (state, action) => {
      state.progressGraphData = action.payload.progressGraphData;
    },
    setEmployeeDashboardLoading: (state, action) => {
      state.employeeDashboardLoading = action.payload;
    },
    setError: (state, action) => {
      state.employeeDashboardError = action.payload.employeeDashboardError;
    },
  },
});

export const {
  setLoading,
  setEmployeeDashboardData,
  setCrrGraphData,
  setAllSurveys,
  setMilMasterData,
  setProgressGraphData,
  setError,
  setEmployeeDashboardLoading,
} = employeeDashboard.actions;
export default employeeDashboard.reducer;

export const getEmployeeDashboardData =
  (surveyId = "") =>
  async (dispatch) => {
    try {
      dispatch(setEmployeeDashboardLoading(true));
      dispatch(setEmployeeDashboardData({ setEmployeeDashboardData: "" }));
      // GET EMployee Dashboard Data api call
      const response = await api.get(
        GET_CLIENT_DASHBOARD.replace("{surveyId}", surveyId)
      );
      if (response) {
        dispatch(setEmployeeDashboardLoading(false));
        if (response.data.error) {
          dispatch(
            setError({
              employeeDashboardError: response.data.error,
            })
          );
        } else {
          dispatch(
            setEmployeeDashboardData({
              employeeDashboardData: response.data?.data,
            })
          );
        }
      }
    } catch (error) {
      dispatch(setEmployeeDashboardLoading(false));
      dispatch(
        setError({
          employeeDashboardError: error,
        })
      );
    }
  };

export const getCrrResults =
  (surveyId = "") =>
  async (dispatch) => {
    try {
      dispatch(setCrrGraphData({ crrGraphData: "" }));
      // GET crr results api call
      const response = await api.get(
        GET_CRR_RESULTS.replace("{surveyId}", surveyId)
      );
      if (response.data.error) {
        dispatch(
          setError({
            employeeDashboardError: response.data.error,
          })
        );
      } else {
        dispatch(
          setCrrGraphData({
            crrGraphData: response.data?.data,
          })
        );
      }
    } catch (error) {
      dispatch(
        setError({
          employeeDashboardError: error,
        })
      );
    }
  };

export const getAllSurveys = () => async (dispatch) => {
  try {
    dispatch(setLoading({ loading: true }));
    const response = await api.get(GET_ALL_SURVEYS);
    if (response) {
      if (response?.data?.error) {
        dispatch(
          setError({
            employeeDashboardError: response.data.error,
          })
        );
      } else {
        dispatch(
          setAllSurveys({
            allSurveysList: response.data?.data,
          })
        );
      }
    }
    dispatch(setLoading({ loading: false }));
  } catch (error) {
    dispatch(setLoading({ loading: false }));
    dispatch(
      setError({
        employeeDashboardError: error,
      })
    );
  }
};

export const getMilMasterData = () => async (dispatch) => {
  try {
    dispatch(setMilMasterData({ milMasterData: "" }));
    const response = await api.get(GET_MIL_MASTERDATA);
    if (response) {
      if (response?.data?.error) {
        dispatch(
          setError({
            employeeDashboardError: response.data.error,
          })
        );
      } else {
        dispatch(
          setMilMasterData({
            milMasterData: response.data?.data,
          })
        );
      }
    }
  } catch (error) {
    dispatch(
      setError({
        employeeDashboardError: error,
      })
    );
  }
};

export const getProgressGraphData = () => async (dispatch) => {
  try {
    dispatch(setProgressGraphData({ progressGraphData: "" }));
    const response = await api.get(GET_PROGRESS_GRAPH_DATA);
    if (response) {
      if (response?.data?.error) {
        dispatch(
          setError({
            employeeDashboardError: response.data.error,
          })
        );
      } else {
        dispatch(
          setProgressGraphData({
            progressGraphData: response.data?.data,
          })
        );
      }
    }
    dispatch(setLoading({ loading: false }));
  } catch (error) {
    dispatch(setLoading({ loading: false }));
    dispatch(
      setError({
        employeeDashboardError: error,
      })
    );
  }
};
